import { render, staticRenderFns } from "./PinterestConfiguration.vue?vue&type=template&id=69d2f148"
import script from "./PinterestConfiguration.vue?vue&type=script&lang=js"
export * from "./PinterestConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports